import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import Checkbox from '@mui/material/Checkbox';

const GridFieldComponent = ({ id, name, typeName, order, label, required, multiple, options, input, meta, language }) => {

  const [selections, setSelections] = useState({});
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (options && options.length > 0) {
      setRows(options.filter(o => o.typeName === 'GRID_ROW'));
      setColumns(options.filter(o => o.typeName === 'GRID_COLUMN'));
    }
  }, [options]);

  const handleRadioChange = (rowId, columnId) => {
    const newSelections = { ...selections, [rowId]: [columnId] };
    setSelections(newSelections);
    emitChange(newSelections);
  };

  const handleCheckboxChange = (rowId, columnId) => {
    const current = selections[rowId] || [];
    let updated;
    if (current.includes(columnId)) {
      updated = current.filter(c => c !== columnId);
    } else {
      updated = [...current, columnId];
    }
    const newSelections = { ...selections, [rowId]: updated };
    setSelections(newSelections);
    emitChange(newSelections);
  };

  const emitChange = (sel) => {
    const result = Object.entries(sel)
      .filter(([, cols]) => cols.length > 0)
      .map(([rowId, columnIds]) => (
        multiple
          ? { rowId: Number(rowId), columnIds }
          : { rowId: Number(rowId), columnId: columnIds[0] }
      ));

    if (result.length > 0) {
      input.onChange({ id, typeName, order, result });
    } else {
      input.onChange(null);
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="grid question">
        <TableHead>
          <TableRow>
            <TableCell />
            {columns.map((col) => (
              <TableCell key={col.id || col.attributeNum} align="center">
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const rowId = row.id || row.attributeNum;
            return (
              <TableRow key={rowId}>
                <TableCell component="th" scope="row">
                  {row.label}
                </TableCell>
                {columns.map((col) => {
                  const colId = col.id || col.attributeNum;
                  const isSelected = (selections[rowId] || []).includes(colId);
                  return (
                    <TableCell key={colId} align="center">
                      {multiple ? (
                        <Checkbox
                          checked={isSelected}
                          onChange={() => handleCheckboxChange(rowId, colId)}
                        />
                      ) : (
                        <Radio
                          checked={isSelected}
                          onChange={() => handleRadioChange(rowId, colId)}
                        />
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GridFieldComponent;
